/* AUTAVEX: one add-to-cart call = one bundle in cart (site-wide) */
(function(){
if(window.__avBundlePatched)return;
window.__avBundlePatched=1;
function newId(){return 'AV'+Date.now().toString(36)+Math.floor(Math.random()*46656).toString(36)}
function tag(body){
  var d;
  try{d=JSON.parse(body)}catch(e){return null}
  if(!d||!d.items||!d.items.length||d.items.length<2)return null;
  for(var i=0;i<d.items.length;i++){
    var pp=d.items[i].properties;
    if(pp&&pp._bundle)return null;
  }
  var bid=newId();
  for(var j=0;j<d.items.length;j++){
    var it=d.items[j];
    if(!it.properties||typeof it.properties!=='object')it.properties={};
    it.properties._bundle=bid;
    if(j===0)it.properties._main='1';
  }
  try{return JSON.stringify(d)}catch(e2){return null}
}
function isAdd(u){return typeof u==='string'&&u.indexOf('/cart/add')>-1}
var of=window.fetch;
if(typeof of==='function'){
  window.fetch=function(u,o){
    try{
      var url=isAdd(u)?u:((u&&typeof u.url==='string')?u.url:'');
      if(url.indexOf('/cart/add')>-1&&o&&typeof o.body==='string'){
        var nb=tag(o.body);
        if(nb)o.body=nb;
      }
    }catch(e){}
    return of.apply(this,arguments);
  };
}
var xs=window.XMLHttpRequest&&window.XMLHttpRequest.prototype;
if(xs&&xs.open&&xs.send){
  var oo=xs.open,os=xs.send;
  xs.open=function(m,u){try{this.__avUrl=u}catch(e){}return oo.apply(this,arguments)};
  xs.send=function(b){
    try{
      if(typeof this.__avUrl==='string'&&this.__avUrl.indexOf('/cart/add')>-1&&typeof b==='string'){
        var nb=tag(b);
        if(nb)return os.call(this,nb);
      }
    }catch(e){}
    return os.apply(this,arguments);
  };
}
})();
